import * as utils from "@/utils";
import store from "@/store";


export async function getEvents(params) {
  let data = await utils.$get(`/api/events/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function deleteAssetMeta(params) {
  let data = await utils.$post("/api/assets/meta/delete/", params);
  return data;
}

export async function getLogs(params) {
  let data = await utils.$get(`/api/logs/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}


export async function getScripts(params) {
  let data = await utils.$get(`/api/atoms/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}


export async function getNodes(params) {
  console.log("geNodes");
  let data = await utils.$get(`/api/nodes/list/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function getTemplates(params) {
  let data = await utils.$get(`/api/templates/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function saveAssetSettings(params) {
  let data = await utils.$post("/api/assets/settings/save/", params);
  return data;
}

export async function getNodeTasks(params) {
  console.log("getNodeTasks");
  let data = await utils.$get(`/api/nodes/tasks/list/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function getScriptsTags() {
  let data = await utils.$get(`/api/atoms/tags/`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });

}

export async function getSingleAtom(hash) {
  let data = await utils.$get(`/api/atom/${hash}/info`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });

}

export async function getTriggers(query, pageNum, pageSize) {
  let data = await utils.$get(`/api/triggers/`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function getSingleTrigger(hash) {
  let data = await utils.$get(`/api/trigger/${hash}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });

}

export async function saveTrigger(params) {
  let data = await utils.$post("/api/trigger/save/", params);
  return data;
}

export async function newNodeTask(params) {
  let data = await utils.$post("/api/tasks/node/save/", params);
  return data;
}


export async function newTask(params) {
    let data = await utils.$post("/api/tasks/sched/save/", params);
    return data;
}

export async function runTask(params) {
  return utils.$post("/api/tasks/run/", params);

}

export async function updateTaskSchedule(params) {
  return utils.$post("/api/tasks/schedule/", params);
}

export async function deleteSchedTask(params) {
  return utils.$post("/api/tasks/sched/delete/", params);
}

export async function pauseTask(params) {

  return utils.$post("/api/tasks/pause/", params);

}

export async function stopTask(params) {

  return utils.$post("/api/tasks/stop/", params);

}

export async function getTasks(query, offset) {

  return utils.$get(
    `/api/tasks/?q=${query}&offset=${offset}`
  );

}

export async function getSingleTask(taskID) {

  return utils.$get(`/api/tasks/${taskID}/info/`);

}

export async function getTaskLogs(taskID) {

  let data = await utils.$get(`/api/task/${taskID}/logs/`);
  return data;

}

export async function loadTaskTablesLabels(taskID, scriptHash) {

  let data = await utils.$get(
    `/api/tasks/${taskID}/tables/labels/?atom=${scriptHash}`
  );
  return data;

}
export async function loadTaskTableData(taskID, scriptHash) {

  let data = await utils.$get(
    `/api/tasks/${taskID}/tables/labels/?atom=${scriptHash}`
  );
  return data;

}

export async function loadTaskTableDataRecord(taskID, atom, hash) {

  let data = await utils.$get(
    `/api/tasks/${taskID}/tables/labels/?atom=${atom}&hash=${hash}`
  );
  return data;

}

export async function getTaskSchedule(taskID) {

  let data = await utils.$get(`/api/task/${taskID}/schedule/`);
  return data;

}

export async function newScript(params) {

  let data = await utils.$post("/api/atoms/save/", params);
  return data;

}

export async function removeScript(id) {

  return utils.$post("/api/atoms/remove/", { id: id });

}

export async function getFiles(params) {

  let data = await utils.$get(`/api/storage/files/?${params}`);
  return data;

}

export async function getTemplate(params) {
  let data = await utils.$get(`/api/templates/view/${params}`);
  return data;
}

export async function getVulnerabilities(params) {
  let data = await utils.$get(`/api/vulnerabilities/?${params}`);
  return new Promise((resolve, reject) => {
    resolve(data);
  });
}

export async function getVulnerability(id) {
  let data = await utils.$get(`/api/vulnerabilities/view/${id}/`);
  return data;
}

export async function getFile(id) {

  let data = await utils.$get(`/api/storage/file/?id=${id}`);
  return data;

}

export async function getFileTypes() {

  let data = await utils.$get(`/api/storage/files/types/`);
  return data;

}
export async function editFile(params) {

  return utils.$post("/api/storage/editFile/", params);

}

export async function getKVSpaces() {

  let data = await utils.$get(`/api/storage/kv/spaces/`);
  return data;

}

export async function getKVSpaceData(params) {

  let data = await utils.$get(`/api/storage/kv/space/data/?${params}`);
  return data;

}

export async function removeFile(params) {

  let data = await utils.$post("/api/storage/removeFile", params);
  return data;

}

export async function executeLuaCode(code) {

  let data = await utils.$post("/api/utils/execute/", { code: code });
  return data;

}

export async function getLuaCode() {

  let data = await utils.$get("/api/utils/code/");
  return data;

}

export async function saveLuaCode(params) {

  let data = await utils.$post("/api/utils/code/", params);
  return data;

}

export async function sendHTTPRequest(params) {

  let data = await utils.$post("/api/webengine/send/", params);
  return data;

}

export async function getSettings() {

  let data = await utils.$get("/api/settings/");
  store.dispatch("updateSettings", data["Settings"]);
  return data;

}

export async function getAbout() {

  return utils.$get("/api/about/");

}

export async function getLists(query, pageNum, pageSize) {

  return utils.$get(`/api/lists/`);

}

export async function getScopes(params) {

  let data = await utils.$get(`/api/scopes/?${params}`);
  return data;

}

export async function addScope(params) {

  let data = await utils.$post("/api/scopes/add/", params);
  return data;

}

export async function removeScope(params) {

  let data = await utils.$post("/api/scopes/remove/", params);
  return data;

}

export async function addAssets(assets) {

  let data = await utils.$post("/api/assets/add/", assets);
  return data;

}

export async function removeAssets(params) {

  let data = await utils.$post("/api/assets/remove/", params);
  return data;

}

export async function getAssets(params) {

  let data = await utils.$get(`/api/assets/?${params}`);
  return data;

}

export async function getAssetsExtra() {

  let data = await utils.$get(`/api/assets/extra/`);
  return data;

}

export async function cloudSync(params) {

  let data = await utils.$post("/api/cloud/sync/", params);
  return data;

}

export async function getCloudSyncStatus() {

  let data = await utils.$get("/api/cloud/sync/");
  return data;

}

export async function updateSettings(params) {

  let data = await utils.$post("/api/settings/", params);
  return data;

}



// WEBPACK FOOTER //
// ./src/api.js